import { Divider, Tabs, useTheme } from '@mui/material';

import { ATSTabbedJobViewNavigationTestIds } from 'data-testids/ATS';
import { CustomTab, DesktopCandidatesLink, tabsSx } from './styles';
import { DesktopNavigationProps } from '../types';
import { useHistory } from 'react-router';
import auth from 'utils/auth';

export const DesktopNavigation: React.FC<DesktopNavigationProps> = ({
  bottomTabsData,
  jobId,
  onChange,
  selectedTab,
  shouldShowDivider,
  topTabsData,
}) => {
  const theme = useTheme();
  const history = useHistory();

  return (
    <Tabs
      data-testid={ATSTabbedJobViewNavigationTestIds.DESKTOP_NAVIGATION}
      onChange={onChange}
      orientation="vertical"
      value={selectedTab}
      sx={tabsSx(theme)}
    >
      {topTabsData.map((tab) => (
        <CustomTab
          data-testid={`${ATSTabbedJobViewNavigationTestIds.DESKTOP_TAB}-${tab.value}`}
          key={tab.value}
          label={tab.label}
          sx={{ display: tab.isVisible ? 'block' : 'none', alignItems: 'flex-start' }}
          value={tab.value}
          onClick={() => {
            history.push(tab.route);
            window.scrollTo(0, 0);
          }}
        />
      ))}
      <Divider
        sx={{ display: shouldShowDivider ? 'block' : 'none', width: '100%', mt: 1, mb: 1 }}
      />
      {auth.isDistrictAdmin() && (
        <DesktopCandidatesLink
          data-testid={ATSTabbedJobViewNavigationTestIds.CANDIDATES_BUTTON}
          to={`/district/requisition-view/${jobId}`}
          target="_blank"
        >
          Candidates
        </DesktopCandidatesLink>
      )}
      {bottomTabsData.map((tab) => (
        <CustomTab
          data-testid={`${ATSTabbedJobViewNavigationTestIds.DESKTOP_TAB}-${tab.value}`}
          key={tab.value}
          label={tab.label}
          sx={{ display: tab.isVisible ? 'block' : 'none' }}
          value={tab.value}
          onClick={() => {
            history.push(tab.route);
            window.scrollTo(0, 0);
          }}
        />
      ))}
    </Tabs>
  );
};
